module.exports = __webpack_public_path__ + "static/media/tools-activities.c1fd66f7.svg";